import React from 'react';
import { useState,useRef } from 'react';
import { Container, Row, Col, Card,Carousel} from 'react-bootstrap';
import '../styles/homepage.css'; // Create this file

import landingImage from '../media/home/landing_image.jpg';
import landingImage2 from '../media/home/landing_image2.jpg';
import { CiCircleCheck } from "react-icons/ci";
import { GrUserWorker } from "react-icons/gr";

import { TbSettingsStar } from "react-icons/tb";
import { LuBadgeDollarSign } from "react-icons/lu";
import { FaWhatsapp } from "react-icons/fa";
import { BiSupport } from "react-icons/bi";
import { IoIosArrowDropdown, IoIosArrowDropup } from "react-icons/io";
import Footer from './footer.jsx'; 
import NNavbar from './navbar.jsx';
import Callback from './callback.jsx'; 
import { useInView,motion } from "framer-motion";


const Home = () => {

   const fadeUpVariant = {
    hidden: { opacity: 0, y: 40 },
    visible: (i) => ({
      opacity: 1,
      y: 0,
      transition: { delay: i * 0.1, duration: 0.4, ease: "easeOut" },
    }),
  };

  const whyQRef = useRef(null);
  const isInView = useInView(whyQRef, { once: true });

  const faqs = [
    {
      question: "Why should I choose Q Plus over hiring an in house accountant?",
      answer: "Q Plus gives you access to an entire team of financial professionals at the cost of one hire. From day-to-day bookkeeping to strategic CFO-level insight, we offer flexible, scalable solutions without the stress of recruitment, training, or overhead."
    },
    {
      question: "What industries do you specialize in ?",
      answer: "We work across a wide range of industries including technology, healthcare, real estate, manufacturing, hospitality, construction, e-commerce and professional services. Our solutions are tailored to the financial regulations and business models of each sector."
    },
    {
      question: "Can your services scale as my business grows?",
      answer: "Yes. Whether you're a startup, SME, or scaling enterprise, our services grow with you. We adapt our support structure to match your pace—ensuring you never outgrow your financial partner."
    },
    {
      question: "How secure is my financial data with Q Plus?",
      answer: "We adhere to strict data governance protocols and ensure complete confidentiality and compliance with both UAE standards and international best practices. Your data is encrypted, securely stored and handled only by authorized personnel."
    },
    {
      question: "Do I need to be based in the UAE to work with you?",
      answer: "Not at all. We support clients across borders, including businesses in the US, UK, Europe, Canada and Australia. Whether you're local or international, we provide region-specific services with global compliance standards."
    },
    {
      question: "What does your CFO Support service include?",
      answer: "Our CFO support includes budgeting, forecasting, board reporting, strategic advisory, financial analysis and investor relations. You get executive-level insights without the full-time cost."
    },
    {
      question: "What’s the first step to get started?",
      answer: "Simply reach out to us for a free consultation. We'll understand your needs, assess your current setup and create a customized financial support plan that fits your goals."
    }
  ];

  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };


  return (
    <>
     
      <NNavbar />
      {/* Hero Section */}
      <section className="home-hero" style={{ backgroundImage: `url(${landingImage})` }}>
      <Container className="py-5">
        {/* Main Heading Content */}
        <h1 className="landing-heading">
          Scale Up Your Business with Professional<br />Accounting Expertise
        </h1>
        <br />
        <p className="landing-subheading">
          We handle your complete financial needs from day-to-day<br />bookkeeping to strategic CFO-level insight.
        </p>
        <br />
        <p className="landing-2subheading">Schedule your free consultation today</p>
        <button className="landing-btn" onClick={() => window.location.href = 'https://wa.me/971556197770?text=Hello%2C%20I%20am%20interested%20in%20your%20accounting%20services%20at%20Qplus%20Management%20Consultancy.%20Please%20share%20more%20details'}>
          <span>GET A QUOTE{"  "}<FaWhatsapp size={22} style={{"marginBottom":"3px"}}/></span>
        </button>
        
        {/* Floating Info Box */}
        {/* Floating Info Box Carousel */}
<div className="d-flex justify-content-end mt-4">
  <div className="info-box-carousel">
    <Carousel fade indicators={false} controls={true} interval={3000}>
      <Carousel.Item>
        <div className="info-box">
          <h5><strong>More Than Just One Accountant</strong></h5><br />
          <p>
            <i>
              Access an expert financial team on-demand. Scalable, flexible, cost-effective—skip payroll headaches, gain performance.
            </i>
          </p>
        </div>
      </Carousel.Item>

      <Carousel.Item>
        <div className="info-box">
          <h5><strong>Less Number Stress, More Business Success</strong></h5><br />
          <p>
            <i>
              We handle bookkeeping, payroll, taxes, CFO guidance—so you can focus on scaling, not spreadsheets.
            </i>
          </p>
        </div>
      </Carousel.Item>

      <Carousel.Item>
        <div className="info-box">
          <h5><strong>Strong Back-End, Stronger Front-End</strong></h5><br />
          <p>
            <i>
             Streamlined, accurate accounting powers your operations - e-commerce, manufacturing, professional services.
            </i>
          </p>
        </div>
      </Carousel.Item>

      <Carousel.Item>
        <div className="info-box">
          <h5><strong>No More Year-End Tax Panic</strong></h5><br />
          <p>
            <i>
              Proactive tax planning keeps you compliant and audit-ready—crucial for hospitality, construction, and finance.
            </i>
          </p>
        </div>
      </Carousel.Item>
    </Carousel>
  </div>
</div>

      </Container>
      </section>


      {/* Why Q Plus */}
      <section className="py-5" id="about" ref={whyQRef}>
  <Container>
    <h2 style={{ fontWeight: "600" }} className="mb-4">
      Why <span style={{ color: "#2E3192", fontWeight: "600" }}>Q Plus?</span>
    </h2>
    <br />
    <motion.div
      custom={3}
      variants={fadeUpVariant}
      initial="hidden"
      animate={isInView ? "visible" : "hidden"}
    >
      <Row className="gy-4">
        <Col md={6} className="yq-text">
          <h5>
            <CiCircleCheck />
            Expert Led Team
          </h5>
          <p>
            Our seasoned professionals bring years<br />
            of multi-industry experience. We grow with<br />
            your business, offering consistent,<br />
            evolving support tailored to your goals.
          </p>
          <br />
          <br />
          <h5>
            <CiCircleCheck />
            Comprehensive Financial Solutions
          </h5>
          <p>
            Beyond bookkeeping, we offer payroll,<br />
            VAT, corporate tax services, periodic<br />
            reporting, CFO-level insights, internal<br />
            and external audits, cost accounting<br />
            and more all under one roof.
          </p>
        </Col>

        <Col md={6} className="yq-text">
          <h5>
            <CiCircleCheck />
            Scalable for All Business Sizes
          </h5>
          <p>
            Whether you’re a solopreneur or<br />
            scaling enterprise, our services flex with<br />
            your growth. We’re trusted across tech,<br />
            retail and manufacturing landscapes.
          </p>
          <br />
          <br />
          <h5>
            <CiCircleCheck />
            Global Expertise, Local Precision
          </h5>
          <p>
            From multi currency accounting to<br />
            GAAP/IFRS compliance, we deliver<br />
            accuracy across borders including the<br />
            US, UK, Europe, Canada and Australia while ensuring<br />
            region specific alignment.
          </p>
        </Col>
      </Row>
    </motion.div>
  </Container>
</section>

      {/* Strength Section */}
      <section className="py-5 strength" style={{ backgroundImage: `url(${landingImage2})`, backgroundSize: 'cover' }}>
        <Container>
          <h2 className="mb-5 our-strength" style={{"fontWeight":"600"}}>OUR <span style={{"color":"#2E3192"}}>STRENGTH</span></h2>
          <br/>
          <p className="text-center" style={{"fontSize":"20px","fontWeight":"400"}}>We bring more than just accounting we bring confidence, clarity and commitment to your business journey.</p><br/>
          <br/>
         <Row className="gy-4 text-center justify-content-center">
  <Col md={6} xs={12}>
    <Card className="strength-card">
      <Card.Body>
        <Row className="align-items-center text-start">
          <Col md={4} xs={4} className="text-center">
            <GrUserWorker size={80} />
          </Col>
          <Col md={8} xs={8}>
          <br/>
            <h5>Experienced Professionals</h5>
            <p>Our team of experts brings deep, cross-industry knowledge to every financial challenge.</p>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  </Col>

  <Col md={6} xs={12}>
    <Card className="strength-card">
      <Card.Body>
        <Row className="align-items-center text-start">
          <Col md={4} xs={4} className="text-center">
            <TbSettingsStar size={80} />
          </Col>
          <Col md={8} xs={8}>
          <br/>
            <h5>Customized Solutions</h5>
            <p>Every business is unique. Our strategies are tailor-made to fit your goals, size and sector.</p>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  </Col>
</Row>

<br />

<Row className="gy-4 text-center justify-content-center">
  <Col md={6} xs={12}>
    <Card className="strength-card">
      <Card.Body>
        <Row className="align-items-center text-start">
          <Col md={4} xs={4} className="text-center">
            <LuBadgeDollarSign size={80} />
          </Col>
          <Col md={8} xs={8}>
          <br/>
            <h5>Transparent Pricing</h5>
            <p>No hidden fees, no guesswork — just straightforward value that matches your needs.</p>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  </Col>

  <Col md={6} xs={12}>
    <Card className="strength-card">
      <Card.Body>
        <Row className="align-items-center text-start">
          <Col md={4} xs={4} className="text-center">
            <BiSupport size={80} />
          </Col>
          <Col md={8} xs={8}>
            <br/>
            <h5>Responsive Support</h5>
            <p>Whether it's a quick query or a major decision, we’re there with answers, insight and action.</p>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  </Col>
</Row>
            <br/><br/><br/><br/>
        </Container>
      </section>

      {/* FAQ Section */}
      <section className="py-5">
      <Container>
        <h2 className="mb-4 faq-title" style={{"fontWeight":"600"}}>
          FREQUENTLY <span className="highlight">ASKED QUESTIONS</span>
        </h2>
        <div className="faq-container">
          {faqs.map((faq, index) => (
            <div key={index} className="faq-item">
              <button className="faq-question" onClick={() => toggle(index)}>
                {faq.question}
                <span className="arrow">{openIndex === index ? <IoIosArrowDropup size={20}/> : <IoIosArrowDropdown size={20}/>}</span>
              </button>
              <div className={`faq-answer ${openIndex === index ? "open" : ""}`}>
                <p>{faq.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </Container>
    </section>

      {/* Call Back Form */}
      <Callback />


      {/* Footer */}
      <Footer />
    </>
  );
};

export default Home;
